import React from 'react';
import styles from './Footer.module.css.js';

var Footer = function Footer(_a) {
  var hashtag = _a.hashtag,
      links = _a.links;
  var linkItems = links === null || links === void 0 ? void 0 : links.map(function (link) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": link.title,
      onClick: link.onClick,
      key: link.title,
      className: styles['footer-link']
    }, link.title);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles['footer-grid']
  }, /*#__PURE__*/React.createElement("button", {
    onClick: hashtag.onClick,
    type: "button",
    "aria-label": hashtag.title,
    className: styles['footer-hashtag']
  }, hashtag.title), /*#__PURE__*/React.createElement("div", {
    className: styles['footer-link-container']
  }, linkItems));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
